<template>
  <div>
    <div style="width: 60%;margin: 50px auto;">
        <img src="../../assets/tmp.png" style="width: 100%;height: auto;" />
        <p class="loading-text" style="font-size: 22px;margin: 20px auto;line-height: 24px;font-weight: 600;color: red;text-align: center;">网站维护中</p>
        <div style="line-height: 24px;">如有紧急情况，请给工作人员留言，后续工作人员会联系您，很抱歉给您带来不便！</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MaintainView'
}
</script>

<style>
.loading-text {
  color: #333;
}

/* 使用伪元素来显示动态省略号 */
.loading-text::after {
  content: '';
  display: inline-block;
  width: 1.5em; /* 预留空间防止文字抖动 */
  text-align: left;
  
  /* 
     animation: 名称 时长 无限循环 阶梯函数;
     steps(3, start) 表示将动画分为3步，且在每步开始时立即变化
  */
  animation: dots 1.5s infinite steps(3, start);
}

@keyframes dots {
  0% {
    content: '.';
  }
  33.33% {
    content: '..';
  }
  66.66% {
    content: '...';
  }
  /* 100% 时会自动回到初始状态或定义为空，这里依靠 steps 和循环特性 */
}
</style>
